<template>
  <div>
    <Menu
      :currentComponent="currentComponent"
      :isMenuHidden="isMenuHidden"
      @change-component="switchComponent"
    />
    <div class="container">
      <component :is="currentComponent" @change-component="switchComponent" />
    </div>
  </div>
</template>

<script>
import Home from './Home.vue'
import Family from './Family.vue'
import ClickingGame from './ClickingGame.vue'
import Playground from './Playground.vue'
import SnakeGame from './SnakeGame.vue'
import ChessGame from './ChessGame.vue'
import Menu from './Menu.vue'

export default {
  name: 'App',
  components: {
    Home,
    Family,
    ClickingGame,
    Playground,
    SnakeGame,
    ChessGame,
    Menu
  },
  data() {
    return {
      currentComponent: 'Home',
      isMenuHidden: false,
      lastScrollY: 0,
      scrollThreshold: 50
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('hashchange', this.handleHashChange)
    // Load component from initial hash
    this.handleHashChange()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('hashchange', this.handleHashChange)
  },
  methods: {
    switchComponent(componentName) {
      window.location.hash = componentName
    },
    handleHashChange() {
      const hash = window.location.hash.slice(1) || 'Home'
      this.currentComponent = hash
    },
    handleScroll() {
      const currentScrollY = window.scrollY
      const scrollDelta = currentScrollY - this.lastScrollY

      // Only hide/show menu on mobile (max-width: 768px)
      // Check via window.innerWidth instead of relying on CSS media query
      if (window.innerWidth <= 768) {
        // Hide menu when scrolling down more than threshold
        if (scrollDelta > this.scrollThreshold && currentScrollY > 100) {
          this.isMenuHidden = true
        }
        // Show menu when scrolling up
        else if (scrollDelta < -this.scrollThreshold) {
          this.isMenuHidden = false
        }
      } else {
        // Always show menu on desktop
        this.isMenuHidden = false
      }

      this.lastScrollY = currentScrollY
    }
  }
}
</script>

<style>
body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  color: #333;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%);
  background-attachment: fixed;
}

p {
  font-size: 1rem;
  line-height: 1.6;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 44px;
}

@media (max-width: 768px) {
  p {
    font-size: 0.9rem;
  }

  main {
    padding: 15px;
  }
}
</style>
